/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateBloodPressureDataInput = {
  date: string,
  device_id: string,
  diastolic?: number | null,
  heart_rate?: number | null,
  systolic?: number | null,
};

export type BloodPressureData = {
  __typename: "BloodPressureData",
  date: string,
  device_id: string,
  diastolic?: number | null,
  heart_rate?: number | null,
  systolic?: number | null,
};

export type CreateESP32SensorDataInput = {
  device_id: string,
  humidity?: number | null,
  pressure?: number | null,
  temperature?: number | null,
  spo2?: number | null,
  heart_rate?: number | null,
  timestamp: string,
};

export type ESP32SensorData = {
  __typename: "ESP32SensorData",
  device_id: string,
  humidity?: number | null,
  pressure?: number | null,
  temperature?: number | null,
  spo2?: number | null,
  heart_rate?: number | null,
  timestamp: string,
};

export type DeleteBloodPressureDataInput = {
  date: string,
  device_id: string,
};

export type DeleteESP32SensorDataInput = {
  device_id: string,
  timestamp: string,
};

export type UpdateBloodPressureDataInput = {
  date: string,
  device_id: string,
  diastolic?: number | null,
  heart_rate?: number | null,
  systolic?: number | null,
};

export type UpdateESP32SensorDataInput = {
  device_id: string,
  humidity?: number | null,
  pressure?: number | null,
  temperature?: number | null,
  spo2?: number | null,
  heart_rate?: number | null,
  timestamp: string,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type BloodPressureDataConnection = {
  __typename: "BloodPressureDataConnection",
  items?:  Array<BloodPressureData | null > | null,
  nextToken?: string | null,
};

export type ESP32SensorDataConnection = {
  __typename: "ESP32SensorDataConnection",
  items?:  Array<ESP32SensorData | null > | null,
  nextToken?: string | null,
};

export type CreateBloodPressureDataMutationVariables = {
  input: CreateBloodPressureDataInput,
};

export type CreateBloodPressureDataMutation = {
  createBloodPressureData?:  {
    __typename: "BloodPressureData",
    date: string,
    device_id: string,
    diastolic?: number | null,
    heart_rate?: number | null,
    systolic?: number | null,
  } | null,
};

export type CreateESP32SensorDataMutationVariables = {
  input: CreateESP32SensorDataInput,
};

export type CreateESP32SensorDataMutation = {
  createESP32SensorData?:  {
    __typename: "ESP32SensorData",
    device_id: string,
    humidity?: number | null,
    pressure?: number | null,
    temperature?: number | null,
    spo2?: number | null,
    heart_rate?: number | null,
    timestamp: string,
  } | null,
};

export type DeleteBloodPressureDataMutationVariables = {
  input: DeleteBloodPressureDataInput,
};

export type DeleteBloodPressureDataMutation = {
  deleteBloodPressureData?:  {
    __typename: "BloodPressureData",
    date: string,
    device_id: string,
    diastolic?: number | null,
    heart_rate?: number | null,
    systolic?: number | null,
  } | null,
};

export type DeleteESP32SensorDataMutationVariables = {
  input: DeleteESP32SensorDataInput,
};

export type DeleteESP32SensorDataMutation = {
  deleteESP32SensorData?:  {
    __typename: "ESP32SensorData",
    device_id: string,
    humidity?: number | null,
    pressure?: number | null,
    temperature?: number | null,
    spo2?: number | null,
    heart_rate?: number | null,
    timestamp: string,
  } | null,
};

export type UpdateBloodPressureDataMutationVariables = {
  input: UpdateBloodPressureDataInput,
};

export type UpdateBloodPressureDataMutation = {
  updateBloodPressureData?:  {
    __typename: "BloodPressureData",
    date: string,
    device_id: string,
    diastolic?: number | null,
    heart_rate?: number | null,
    systolic?: number | null,
  } | null,
};

export type UpdateESP32SensorDataMutationVariables = {
  input: UpdateESP32SensorDataInput,
};

export type UpdateESP32SensorDataMutation = {
  updateESP32SensorData?:  {
    __typename: "ESP32SensorData",
    device_id: string,
    humidity?: number | null,
    pressure?: number | null,
    temperature?: number | null,
    spo2?: number | null,
    heart_rate?: number | null,
    timestamp: string,
  } | null,
};

export type GetBloodPressureDataQueryVariables = {
  date: string,
  device_id: string,
};

export type GetBloodPressureDataQuery = {
  getBloodPressureData?:  {
    __typename: "BloodPressureData",
    date: string,
    device_id: string,
    diastolic?: number | null,
    heart_rate?: number | null,
    systolic?: number | null,
  } | null,
};

export type GetESP32SensorDataQueryVariables = {
  device_id: string,
  timestamp: string,
};

export type GetESP32SensorDataQuery = {
  getESP32SensorData?:  {
    __typename: "ESP32SensorData",
    device_id: string,
    humidity?: number | null,
    pressure?: number | null,
    temperature?: number | null,
    spo2?: number | null,
    heart_rate?: number | null,
    timestamp: string,
  } | null,
};

export type ListBloodPressureDataQueryVariables = {
  device_id: string,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBloodPressureDataQuery = {
  listBloodPressureData?:  {
    __typename: "BloodPressureDataConnection",
    items?:  Array< {
      __typename: "BloodPressureData",
      date: string,
      device_id: string,
      diastolic?: number | null,
      heart_rate?: number | null,
      systolic?: number | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListESP32SensorDataQueryVariables = {
  device_id: string,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListESP32SensorDataQuery = {
  listESP32SensorData?:  {
    __typename: "ESP32SensorDataConnection",
    items?:  Array< {
      __typename: "ESP32SensorData",
      device_id: string,
      humidity?: number | null,
      pressure?: number | null,
      temperature?: number | null,
      spo2?: number | null,
      heart_rate?: number | null,
      timestamp: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type OnCreateBloodPressureDataSubscriptionVariables = {
  date?: string | null,
  device_id?: string | null,
  diastolic?: number | null,
  heart_rate?: number | null,
  systolic?: number | null,
};

export type OnCreateBloodPressureDataSubscription = {
  onCreateBloodPressureData?:  {
    __typename: "BloodPressureData",
    date: string,
    device_id: string,
    diastolic?: number | null,
    heart_rate?: number | null,
    systolic?: number | null,
  } | null,
};

export type OnCreateESP32SensorDataSubscriptionVariables = {
  device_id?: string | null,
  temperature?: number | null,
  spo2?: number | null,
  heart_rate?: number | null,
  timestamp?: string | null,
};

export type OnCreateESP32SensorDataSubscription = {
  onCreateESP32SensorData?:  {
    __typename: "ESP32SensorData",
    device_id: string,
    humidity?: number | null,
    pressure?: number | null,
    temperature?: number | null,
    spo2?: number | null,
    heart_rate?: number | null,
    timestamp: string,
  } | null,
};

export type OnDeleteBloodPressureDataSubscriptionVariables = {
  date?: string | null,
  device_id?: string | null,
  diastolic?: number | null,
  heart_rate?: number | null,
  systolic?: number | null,
};

export type OnDeleteBloodPressureDataSubscription = {
  onDeleteBloodPressureData?:  {
    __typename: "BloodPressureData",
    date: string,
    device_id: string,
    diastolic?: number | null,
    heart_rate?: number | null,
    systolic?: number | null,
  } | null,
};

export type OnDeleteESP32SensorDataSubscriptionVariables = {
  device_id?: string | null,
  temperature?: number | null,
  spo2?: number | null,
  heart_rate?: number | null,
  timestamp?: string | null,
};

export type OnDeleteESP32SensorDataSubscription = {
  onDeleteESP32SensorData?:  {
    __typename: "ESP32SensorData",
    device_id: string,
    humidity?: number | null,
    pressure?: number | null,
    temperature?: number | null,
    spo2?: number | null,
    heart_rate?: number | null,
    timestamp: string,
  } | null,
};

export type OnUpdateBloodPressureDataSubscriptionVariables = {
  date?: string | null,
  device_id?: string | null,
  diastolic?: number | null,
  heart_rate?: number | null,
  systolic?: number | null,
};

export type OnUpdateBloodPressureDataSubscription = {
  onUpdateBloodPressureData?:  {
    __typename: "BloodPressureData",
    date: string,
    device_id: string,
    diastolic?: number | null,
    heart_rate?: number | null,
    systolic?: number | null,
  } | null,
};

export type OnUpdateESP32SensorDataSubscriptionVariables = {
  device_id?: string | null,
  temperature?: number | null,
  spo2?: number | null,
  heart_rate?: number | null,
  timestamp?: string | null,
};

export type OnUpdateESP32SensorDataSubscription = {
  onUpdateESP32SensorData?:  {
    __typename: "ESP32SensorData",
    device_id: string,
    humidity?: number | null,
    pressure?: number | null,
    temperature?: number | null,
    spo2?: number | null,
    heart_rate?: number | null,
    timestamp: string,
  } | null,
};
